import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Button } from '@ow/comps'
import deleteImg from '../../assets/web/delete_1.png'
import editImg from '../../assets/web/edit_1.png'
import addImg from '../../assets/web/add.png'
import AddGroup from './operateGroup'
import BatchOperate from '../user/BatchOperate'
import AddUser from '../../add-user'

const Head = styled.div`
  &:hover .opt-group {
    visibility: visible !important;
  }
`
const OperateHeader = function ({
  appId,
  checkedUsers = [],
  cancleSeletedUsers,
  usersMutate,
  useOrg,
  useUserApi,
}) {
  // const addRef = useRef(null)
  const { currentOrg, currentGroup, fetchOrgs, orgOperate } = useOrg
  const [operateType, setOperateType] = useState(null)
  const [popupOpen, setOpen] = useState(false)
  const [isAdd, setIsAdd] = useState(false)
  console.log('user->>', currentOrg)

  const onClickAddGroup = () => {
    setOperateType('add')
    setOpen(true)
  }
  const onClickEditGroup = () => {
    setOperateType('edit')
    setOpen(true)
  }

  const onConfirmDelete = () => {
    orgOperate.deleteOrg()
  }

  const renderImg = (icon, onClick) => {
    return (
      <div className="ml-4" onClick={onClick}>
        <img alt="" className="w-4 h-4 cursor-pointer" src={icon} />
      </div>
    )
  }
  const renderGroup = () => {
    if (currentGroup === 'unApproved') {
      return '待审批'
    }
    if (currentGroup === 'unGrouped') {
      return '未分组'
    }
    if (currentGroup === 'resigned') {
      return '已离职'
    }
    if (currentGroup === 'disabled') {
      return '已禁用'
    }
    if (currentGroup === 'all') {
      return '全部用户'
    }
    return '未激活'
  }
  const renderOrgName = (name) => {
    return name && name.length > 20 ? name.substring(0, 20) + '...' : name
  }

  return (
    <>
      <Head
        className="header overflow-x-auto w-full px-5 flex sm:justify-between flex-row flex-nowrap items-center border-gray-200"
        style={{ height: '3.8625rem' }}
      >
        <div className="flex justify-between flex-row flex-nowrap items-center text-sm sm:text-base">
          <span>
            <b>
              {currentOrg
                ? renderOrgName(currentOrg.extData.label)
                : renderGroup()}
            </b>
          </span>
          <div
            className="opt-group w-32 sm:w-auto flex justify-between flex-row flex-nowrap"
            style={{ visibility: 'hidden' }}
          >
            {currentOrg && renderImg(addImg, onClickAddGroup, '添加下级组织')}
            {currentOrg && renderImg(editImg, onClickEditGroup, '编辑')}
            {currentOrg && renderImg(deleteImg, onConfirmDelete, '删除')}
          </div>
        </div>
        <div className="flex justify-between flex-row flex-nowrap">
          {checkedUsers.length > 0 && (
            <BatchOperate
              appId={appId}
              selectedUsers={checkedUsers}
              cancleSeletedUsers={cancleSeletedUsers}
              usersMutate={usersMutate}
              useUserApi={useUserApi}
              useOrgApi={useOrg}
            />
          )}
          {checkedUsers.length === 0 && (
            <Button
              type="primary"
              onClick={() => {
                setIsAdd(true)
              }}
            >
              添加用户
            </Button>
          )}
        </div>
        <AddGroup
          appId={appId}
          action={operateType}
          title={operateType === 'edit' ? '编辑组织' : '添加下级组织'}
          fetchOrgs={fetchOrgs}
          useOrg={useOrg}
          closeModal={() => {
            setOpen(false)
          }}
          open={popupOpen}
        />
        {/* {isVisibleDelete && (
          <DeleteModal
            open={isVisibleDelete}
            closeModal={onClickCloseDeleteModal}
            onClickConfirm={onConfirmDelete}
            title={delMsg || '确定要删除该组织吗？'}
            note={delMsg ? '' : '删除后不可恢复！'}
            isNotCanDel={delMsg}
          />
        )} */}
      </Head>
      <AddUser
        title="添加用户"
        useOrgApi={useOrg}
        appId={appId}
        open={isAdd}
        usersMutate={usersMutate}
        closeModal={() => {
          setIsAdd(false)
          // if (addRef.current) {
          //   addRef.current.close()
          //   usersMutate()
          // }
        }}
        // ref={addRef}
      />
    </>
  )
}

export default OperateHeader
